import React from 'react';
import { ArrowRight } from 'lucide-react';
import { CinematicScene } from '../CinematicScene';
import { Reveal } from '../Reveal';
import { imagery } from '../../data/site';
import { MotionMode } from '../../types/motion';
interface KitchenSceneProps {
  motionMode?: MotionMode;
}
export function KitchenScene({
  motionMode = 'cinematic'
}: KitchenSceneProps) {
  return <CinematicScene id="kitchen" image={imagery.food} imageAlt="Artisan sourdough toast and a seasonal grain bowl plated on dark ceramics" motionMode={motionMode} scrim="left" data-id="element-69" data-mp="1fylyhyed90gn">
      <div className="flex h-full w-full items-center" data-id="element-70" data-mp="s7ggbckydw36">
        <div className="max-w-xl px-6 md:px-16 lg:px-24" data-id="element-71" data-mp="s5wyhhjnfcza">
          <Reveal data-id="element-72" data-mp="w920zk3qbenx">
            <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.3em] text-brass" data-id="element-73" data-mp="w9l805rucin6">
              The Fine Foods
            </p>
          </Reveal>

          <Reveal delay={0.12} data-id="element-74" data-mp="27nozn5ayhup2">
            <h2 className="font-display text-[2.1rem] font-normal leading-[1.15] text-cream md:text-5xl" data-id="element-75" data-mp="27mxgwv2gjrg7">
              A KITCHEN WITHOUT
              <br data-id="element-76" data-mp="cpag6rly0uoh" />
              COMPROMISE.
            </h2>
          </Reveal>

          <Reveal delay={0.24} data-id="element-77" data-mp="7sth52d7gvwm">
            <p className="mt-7 max-w-md font-mono text-[12px] leading-[1.95] text-stone md:text-[12.5px]" data-id="element-78" data-mp="2t74ov57bjov">
              We believe food should be as inspiring as the coffee it
              accompanies. Our kitchen specializes in vibrant, seasonal
              flavors—from artisan sourdough toasts to sophisticated
              bowls—designed to nourish the body and delight the palate.
            </p>
          </Reveal>

          <Reveal delay={0.36} data-id="element-79" data-mp="3g7k9hh1lmj1g">
            <a href="#coffee" className="group mt-9 inline-flex items-center gap-3 border-b border-brass-dim pb-2 font-mono text-[10.5px] uppercase tracking-[0.2em] text-brass transition-colors hover:border-cream hover:text-cream" data-id="element-80" data-mp="3g8myfjfd2beq">
              View the Full Menu
              <ArrowRight className="h-3.5 w-3.5 transition-transform duration-500 group-hover:translate-x-1.5" aria-hidden="true" data-id="element-81" data-mp="328u99sjhg38v" />
            </a>
          </Reveal>
        </div>
      </div>
    </CinematicScene>;
}